<script setup lang="ts">
import type { AvatarProps } from '/#/components/base/avatar/avatar'
import type { ComputedRef } from 'vue'

import isUndefined from 'lodash-es/isUndefined'

import { getNameInitials } from '/@/utils/string'

const props = withDefaults(defineProps<AvatarProps>(), {
  text: undefined,
  image: undefined,
  color: undefined,
  shape: 'circle',
  size: 'md',
})

/**
 * @name textFirstLetters
 * @description Returns first letters of the text. IF text is undefined, returns 'N/A'
 */
const textFirstLetters: ComputedRef<string> = computed(() =>
  props.text ? getNameInitials(props.text) : 'N/A',
)

/**
 * @name tooltipText
 * @description Returns tooltip text if showTooltip is true
 */
const tooltipText: ComputedRef<string | undefined> = computed(() =>
  props.showTooltip ? props.text : undefined,
)

const appearance: ComputedRef<Array<string | boolean | undefined>> = computed(() => [
  props.shape,
  props.size,
  props.color,
  props.highlight && 'highlight',
  !isUndefined(props.image) && 'with-image',
])
</script>

<template>
  <div class="avatar-wrapper">
    <div v-tippy="tooltipText" class="avatar" :class="appearance">
      <span class="avatar-text">
        {{ textFirstLetters }}
      </span>
      <div v-if="props.image" class="avatar-image">
        <img
          :src="props.image"
          alt="avatar"
         
          @error="$emit('error', $event)"
        />
      </div>
    </div>
  </div>
</template>
